<template>
	<div>
		<filter-panel style="width: 100%" :data="group" @search="filterChange"></filter-panel>
		<data-list
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="column"
			:loading="loading"
		></data-list>
		<!-- 新增用户 -->
		<dialog-form
			:dialogVisible="showDialog"
			:attributes="attributes"
			:showBtn="false"
			@close:dialogVisible="close"
		>
			<sky-add-input
				slot="main"
				:dataList="dataList"
				:disabled="disabled"
				@add-data="addData"
				@delete-data="deleteData"
			></sky-add-input>
		</dialog-form>
	</div>
</template>

<script>
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import setmeal from '@/backend/services/account/setmeal.js';
import dialogForm from '@/components/dialogForm/dialogForm';
import skyAddInput from '@/components/iglobalwin/formComponents/sky-add-input.vue';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import editText from '@/components/tools/edit_text';

const list = listPageCreate({
	searchConfig: {
		api: api.setmeal.grayscaleList,
		method: 'POST',
	},
});
export default {
	mixins: [list],
	data() {
		return {
			group: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '灰度名称',
						label: '灰度名称',
						prop: 'name',
						value: '',
					},
				],
			},
			column: [],
			showDialog: false,
			attributes: {
				title: '',
				width: '30%',
			},
			dataList: [],
			activeVal: {},
			disabled: true,
		};
	},
	mounted() {
		this.setColumn();
		this.query();
	},
	methods: {
		setColumn() {
			let that = this;
			this.column = [
				{
					label: '功能菜单名称',
					bind: 'name',
				},
				{
					label: '前端版本',
					bind: 'version',
				},
				{
					label: '使用客户',
					bind: 'customerCount',
					type: 'percentage',
					style: {
						color: '#409EFF',
						cursor: 'pointer',
					},
					webskip(val, row) {
						that.redactGrayscaleList(row);
					},
				},
				{
					label: '灰度名称',
					type: 'custom',
					bind: 'grayName',
					componentName: editText,
					config: {
						componentType: 'sky-input',
					},
					triggerEvent({ id }, data, cb) {
						that.updateGrayscaleName(id, data, cb);
					},
				},
				{
					label: '状态',
					bind: 'openingUp',
					type: 'percentage',
					dataStyle(val) {
						return val ? '灰度' : '发布';
					},
				},
				{
					label: '操作',
					type: 'iconbutton',
					align: 'center',
					iconlist: [
						{
							name: 'fabu',
							message: '全量发布',
							style: {
								color: '#5CAFFF',
							},
							show({ openingUp }) {
								return openingUp;
							},
							callback(row) {
								that
									.$confirm(
										'发布后，所有客户将使用当前灰度前端版本，请谨慎操作，是否发布？',
										'灰度发布',
										{
											confirmButtonText: '确定',
											cancelButtonText: '取消',
											type: 'warning',
										}
									)
									.then(() => {
										that.release(row.id, true);
									})
									.catch(() => {
										that.$message({
											message: '取消发布',
											type: 'warning',
										});
									});
							},
						},
						{
							name: 'huitui',
							message: '回退',
							show({ openingUp }) {
								return !openingUp;
							},
							callback(row) {
								that
									.$confirm(
										'回退后后，所有客户将使用之前灰度前端版本，请谨慎操作是否回退？',
										'发布回退',
										{
											confirmButtonText: '确定',
											cancelButtonText: '取消',
											type: 'warning',
										}
									)
									.then(() => {
										that.release(row.id, false);
									})
									.catch(() => {
										that.$message({
											message: '取消回退',
											type: 'warning',
										});
									});
							},
						},
					],
				},
			];
		},
		async redactGrayscaleList(row) {
			if (!row) {
				this.$message.info('数据错误，请稍后重试');
				return false;
			}
			try {
				this.attributes.title = row.name || '';
				let { data } = await setmeal.redactGrayscaleList({ id: row.id });
				this.dataList = data.data;
				this.activeVal = row;
				this.disabled = Boolean(row.openingUp);
				this.showDialog = true;
			} catch (error) {
				this.$message.warning('请求错误，请稍后重试');
			}
		},
		// 新增
		async addData(val, cb) {
			try {
				let customerId = val;
				let { id, version } = this.activeVal;
				await setmeal.addGrayscale({
					customerId,
					version,
					menuPermissionsId: id,
				});
				this.$message.success('添加成功');
				this.redactGrayscaleList(this.activeVal);
				cb();
			} catch (error) {
				this.$message.warning('添加失败');
			}
		},
		// 删除
		async deleteData({ id }) {
			try {
				await setmeal.deleteGrayscale({ id });
				this.redactGrayscaleList(this.activeVal);
				this.$message.success('删除成功');
			} catch (error) {
				this.$message.warning('删除失败');
			}
		},
		// 发布
		async release(id, publish) {
			try {
				await setmeal.releaseGrayscaleVersion(
					{ id },
					{
						publish,
					}
				);
				this.query();
				this.$message({
					message: '发布成功',
					type: 'success',
				});
			} catch (error) {
				console.log(error);
				debugger;
			}
		},
		async updateGrayscaleName(id, data, cb) {
			try {
				await setmeal.updateGrayscaleName({
					grayName: data,
					menuPermissionsId: id,
				});
				this.query();
				this.$message.success('设置成功');
				cb();
			} catch (err) {
				this.$message.warning('设置失败');
			}
		},
		close(val) {
			this.query();
			this.showDialog = val;
		},
	},
	components: { dialogForm, skyAddInput, filterPanel },
};
</script>

<style lang="scss" scoped></style>
